"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@starknet-react/core");
const controller_1 = __importDefault(require("@cartridge/controller"));
class ControllerConnector extends core_1.Connector {
    constructor(policies, options) {
        super({ options });
        this._account = null;
        this.controller = new controller_1.default(policies, options);
    }
    id() {
        return "cartridge";
    }
    name() {
        return "Cartridge";
    }
    available() {
        return true;
    }
    ready() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.controller.ready();
        });
    }
    register(username, credentialId, credential) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.controller.register(username, credentialId, credential);
        });
    }
    login(address, credentialId, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.controller.login(address, credentialId, options);
        });
    }
    provision(address, credentialId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.controller.provision(address, credentialId);
        });
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            this._account = yield this.controller.connect();
            if (!this._account) {
                throw new Error("account not found");
            }
            return this._account;
        });
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.controller.disconnect();
        });
    }
    account() {
        return Promise.resolve(this._account);
    }
    issueStarterPack(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.controller.issueStarterPack(id);
        });
    }
    showQuests(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.controller.showQuests(gameId);
        });
    }
    initEventListener(accountChangeCb) {
        // TODO
        return Promise.resolve();
    }
    removeEventListener(accountChangeCb) {
        // TODO
        return Promise.resolve();
    }
}
exports.default = ControllerConnector;
